import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { RuleDetailsTimeCell } from "../cells/RuleDetailsTimeCell";
import { RuleDetailsGroupCell } from "../cells/RuleDetailsGroupCell";
import { RuleDetailsFromCell } from "../cells/RuleDetailsFromCell";
import { RuleDetailsToCell } from "../cells/RuleDetailsToCell";
import { RuleDetailsActionsCell } from "../cells/RuleDetailsActionsCell";
import { RuleDetailsEditCell } from "../cells/RuleDetailsEditCell";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";

export enum TransferRuleDetailsColumn {
    TIME = "time",
    GROUP = "group",
    FROM = "from",
    TO = "to",
    ACTIONS = "actions",
    EDIT = "edit",
}

export const transferHistoryRuleDetailsTableViewConfig: ViewConfig<
    RuleDetailsRowData,
    TransferRuleDetailsColumn,
    never
> = {
    columns: {
        [TransferRuleDetailsColumn.TIME]: {
            accessorKey: "logDate",
            name: "Time",
            header: "",
            cell: RuleDetailsTimeCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [TransferRuleDetailsColumn.GROUP]: {
            accessorKey: "groupColumn",
            name: "Group",
            header: "Group",
            cell: RuleDetailsGroupCell,
            minSize: 170,
            maxSize: 220,
        },
        [TransferRuleDetailsColumn.FROM]: {
            accessorKey: "conditions",
            name: "From",
            header: "From",
            cell: RuleDetailsFromCell,
            minSize: 280,
            maxSize: 700,
        },
        [TransferRuleDetailsColumn.TO]: {
            accessorKey: "conditions",
            name: "To",
            header: "To",
            cell: RuleDetailsToCell,
            minSize: 280,
            maxSize: 700,
        },
        [TransferRuleDetailsColumn.ACTIONS]: {
            accessorKey: "actions",
            name: "Actions",
            header: "Actions",
            cell: RuleDetailsActionsCell,
            minSize: 260,
            maxSize: 700,
        },
        [TransferRuleDetailsColumn.EDIT]: {
            accessorKey: "resource",
            name: "",
            header: "",
            cell: RuleDetailsEditCell,
            minSize: 64,
            maxSize: 80,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
